import React, { useRef } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { TestimonialCard } from '../TestimonialCard';
import { AppI18n, appTranslate } from '../../i18n';
import { SECTION_IDS } from '../../../consts';
import type { Testimonial } from '../../../server/data/testimonials';
import { headingWrapClassName, headingClassName } from './style.ve.css';
import { useCardsAnimation } from './useCardsAnimation';
import { PRE_FADE_HOLD_VH, CARD_HOLD_VH } from './animationConstants';

interface TestimonialsSectionProps {
    testimonials: Testimonial[];
}

export const TestimonialsSection = ({ testimonials }: TestimonialsSectionProps) => {
    const sectionRef = useRef<HTMLElement>(null);

    useCardsAnimation({ sectionRef });

    return (
        <Container as="section" ref={sectionRef} id={SECTION_IDS.testimonials} width="100%" flexShrink={0}>
            <Container className={headingWrapClassName}>
                <Typography
                    as="h2"
                    color="black"
                    fontWeight="semibold"
                    textAlign="center"
                    width="100%"
                    className={headingClassName}
                >
                    <AppI18n k="testimonials.heading" />
                </Typography>
            </Container>

            {testimonials.map(({ id, name, defaultImages, hoverImages }, i) => (
                <Container key={id} data-card-wrapper height={`${100 + PRE_FADE_HOLD_VH + CARD_HOLD_VH}vh`}>
                    <Container position="sticky" top={0} height="100vh" overflow="hidden" width="100%">
                        <Container position="relative" width="100%" height="100%">
                            <TestimonialCard
                                index={i + 1}
                                name={name}
                                defaultImages={defaultImages}
                                hoverImages={hoverImages}
                                role={appTranslate(`testimonials.items.${id}.role`)}
                                quote={appTranslate(`testimonials.items.${id}.quote`)}
                                body={appTranslate(`testimonials.items.${id}.body`)}
                            />
                        </Container>
                    </Container>
                </Container>
            ))}
        </Container>
    );
};
